import { Controller } from "@hotwired/stimulus"

/**
 * The new-floorplan form: says, under the floor chosen, when it has no zone.
 *
 * A plan can be drawn on any floor of the building, but its aisles and legs
 * can only be created in facilities in a zone — so a floor with none is worth
 * a word before the plan is made, not only when its first Sync is refused.
 * The counts are the server's (`counts`: floor → zones).
 */
export default class extends Controller {
  static targets = ["hint"]
  static values = { counts: Object }

  connect() {
    this.check()
  }

  /** data-action="change->floorplans--floor-zones#check" */
  check() {
    if (!this.hasHintTarget) return
    const floor = this.element.querySelector("[name='drawing[floor]']")?.value
    const zones = this.countsValue?.[floor]
    this.hintTarget.hidden = !(typeof zones === "number" && zones === 0)
  }
}
